<template>
  <div style="width: 100%;height: 100%;">
    <div class="logo"><img src="@/assets/images/logo.png" alt=""></div>
    <div class="login_container">
      <!-- <div class="index-logo"><img src="@/assets/images/piya.svg" alt=""><span>皮丫影像</span></div> -->
      <LoginBox />
    </div>
  </div>
</template>

<script>
import LoginBox from './LoginBox.vue'

export default {
  name: 'login',
  components: {
    LoginBox
  }

}
</script>
<style lang="less" scoped>
@deep: ~">>>";

.forget-title {
  opacity: 1;
  font-size: 28px;
  font-family: Source Han Sans CN, Source Han Sans CN-Bold;
  font-weight: 700;
  text-align: left;
  margin: 0 0 10px 29px;
}

.forget-text {
  font-size: 14px;
  font-family: Source Han Sans CN, Source Han Sans CN-Regular;
  font-weight: 400;
  text-align: left;
  color: #505050;
  margin: 0 0 15px 29px;
}

.verification-code {
  .el-input {
    width: 156px;
  }

  .el-button {
    float: right;
    line-height: 43px;
    border: 1px solid #eee;
    padding: 0;
    width: 97px;
    text-align: center;
    background: rgba(127, 127, 127, 1);
    height: 45px !important;

    @{deep} span {
      color: #fff;
    }
  }

  .bg-text {
    background: #ccc;
  }
}

.login_container {
  // background: url("https://data.piyaps.com/web-image/70061/6db8b8897f0d7273a48f83f8c738692c.png") no-repeat center;
  background: url("../../assets/images/new-bg.png") no-repeat;
  background-size: cover;

  // background: orange;
  width: 100%;
  // height: 100%;
  // display: flex;
  // justify-content: flex-end;
  // align-items: center;
  // position: relative;
}

.logo {
  padding: 10px 20px;
  box-sizing: border-box;

  img {
    // width: 32px;
    height: 32px;
  }
}

.index-logo {
  position: fixed;
  width: 100%;
  height: 74px;
  top: 0;
  left: 0;
  background: rgb(242, 242, 242);
  box-shadow: 0 2px 2px rgba(85, 85, 85, 0.4);
  display: flex;
  align-items: center;

  img {
    width: 56px;
    margin-left: 140px;
  }

  span {
    font-size: 27px;
    margin: 0 0 0 14px;
  }
}

.login_box {
  width: 557px;
  position: absolute;
  top: 180px;
  right: 18%;

  .scan-height {
    height: 100%;
    width: 100%;
  }

  .forget_password {
    font-size: 12px;
    text-align: right;
    line-height: 22px;
    padding: 10px 0;
    color: #999;
    cursor: pointer;
  }
}

.avatar_box {
  margin: 0 0 10px;
  text-align: center;

  h3 {
    line-height: 50px;
    font-size: 22px;
    color: #333;
  }

  p {
    font-size: 12px;
    color: #999;
    letter-spacing: 0;
  }
}

@{deep} .el-tabs__nav-wrap {
  &:after {
    display: none;
  }

  .el-tabs__nav-scroll {
    display: flex;
    justify-content: center;
  }

  .el-tabs__item {
    color: #999;
    font-size: 18px;
  }

  .el-tabs__item.is-active {
    color: #333;
  }

  .el-tabs__active-bar {
    background: #999;
    height: 4px;
    width: 17px !important;
    left: 27px;
  }
}

.login_from {
  width: 269px;
  box-sizing: border-box;
  margin: 0 auto;

  .el-input {
    width: 100%;
    margin-right: 0;
  }

  @{deep} .el-form-item {
    display: flex;
    flex-flow: column;
    margin-bottom: 10px;
  }

  @{deep} .el-form-item__label {
    text-align: left;
  }

  @{deep} .el-form-item__content {
    margin-left: 0px !important;
  }

  @{deep} .el-input__inner {
    height: 45px !important;
    line-height: 45px !important;
    font-size: 12px;
    color: #666;
    padding: 0 40px;
  }

  @{deep} .is-error .el-input__inner {
    border: 1px solid #dcdfe6;
  }

  .el-form-item__error2 {
    position: absolute;
    right: 0;
    bottom: -20px;
    color: #f56c6c;
    font-size: 12px;
    line-height: 1;
  }
}

.quick-load {
  .verification-code {
    .el-input {
      width: 156px;
    }

    .el-button {
      float: right;
      line-height: 43px;
      border: 1px solid #eee;
      padding: 0;
      width: 97px;
      text-align: center;
      background: rgba(127, 127, 127, 1);
      height: 45px !important;

      @{deep} span {
        color: #fff;
      }
    }

    .bg-text {
      background: #ccc;
    }
  }
}

.login_btn {
  width: 269px;
  margin-top: 25px;

  @{deep} button {
    display: block;
    width: 100%;
    background: #333;
    border-radius: 5px;
    color: #fff;
    height: 45px !important;
    padding: 0;
    box-shadow: none;
    border: none;
    cursor: pointer;

    span {
      font-size: 18px;
    }

    &:hover {
      opacity: 0.65;
    }
  }
}
</style>
